/* CommerceGenie site scripts, ported from the approved draft (version 33) on 2026-10-17 (#22).
   Each part runs only when its elements are on the page. No single-page router: every page is a real address. */
(function () {
  // phone drawer
  var drawer = document.getElementById("drawer"), menuBtn = document.getElementById("menu-btn");
  if (drawer && menuBtn) {
    menuBtn.addEventListener("click", function () {
      var open = !drawer.classList.contains("open");
      drawer.classList.toggle("open", open);
      menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("open")) { drawer.classList.remove("open"); menuBtn.setAttribute("aria-expanded", "false"); menuBtn.focus(); }
    });
  }
  // top menu: click or tap opens, Escape or a click outside closes and gives focus back to the button
  var dds = [].slice.call(document.querySelectorAll(".nd"));
  function closeAll(except) {
    dds.forEach(function (d) { if (d !== except) { d.classList.remove("open"); d.querySelector(".nd-btn").setAttribute("aria-expanded", "false"); } });
  }
  dds.forEach(function (d) {
    var b = d.querySelector(".nd-btn");
    b.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = !d.classList.contains("open");
      closeAll(d); d.classList.toggle("open", open); b.setAttribute("aria-expanded", String(open));
      // closing by its own button hides the panel even while focus or the mouse is still inside it
      d.classList.toggle("shut", !open);
    });
    d.addEventListener("mouseleave", function () { d.classList.remove("shut"); });
    d.addEventListener("focusout", function (e) { if (!d.contains(e.relatedTarget)) { d.classList.remove("open", "shut"); b.setAttribute("aria-expanded", "false"); } });
  });
  document.addEventListener("click", function (e) { if (!e.target.closest(".nd")) closeAll(); });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var open = dds.filter(function (d) { return d.classList.contains("open"); })[0];
    closeAll();
    if (open) { open.classList.add("shut"); open.querySelector(".nd-btn").focus(); }
  });
  // the current page lights up in the menus
  var here = location.pathname.replace(/\/$/, "") || "/";
  [].forEach.call(document.querySelectorAll("header.top a[href], .drawer a[href], footer.site a[href]"), function (a) {
    var p = (a.getAttribute("href") || "").replace(/[?#].*$/, "").replace(/\/$/, "") || "/";
    if (p === here) { a.classList.add("on"); a.setAttribute("aria-current", "page"); }
  });
  dds.forEach(function (d) {
    var on = !!d.querySelector(".nd-panel a.on") || (here.indexOf("/pages/agent-apps/") === 0 && !!d.querySelector('.nd-panel a[href="/pages/agent-apps"]'));
    d.querySelector(".nd-btn").classList.toggle("on", on);
  });
})();
// forms: required fields and a well-formed email are checked before the form is sent.
// Shopify's spam protection (hCaptcha) listens to every submit of a contact form and sends it itself, even when
// another script cancelled it; so the check listens first (capture on window) and a form that fails stops there.
(function () {
  var forms = [].slice.call(document.querySelectorAll("form[data-cg-check]"));
  if (forms.length) window.addEventListener("submit", function (e) {
    var form = e.target;
    if (forms.indexOf(form) < 0) return;
    var fields = [].slice.call(form.querySelectorAll("[required]"));
    var bad = fields.filter(function (f) { var v = (f.value || "").trim(); return !v || (f.type === "email" && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)); });
    fields.forEach(function (f) { f.classList.toggle("p7-bad", bad.indexOf(f) >= 0); f.setAttribute("aria-invalid", bad.indexOf(f) >= 0 ? "true" : "false"); });
    if (bad.length) { e.preventDefault(); e.stopImmediatePropagation(); bad[0].focus(); return; }
    var nm = document.getElementById(form.getAttribute("data-cg-name") || "");
    try { if (nm && form.id) sessionStorage.setItem("cg-sent-" + form.id, nm.value.trim().split(/\s+/)[0]); } catch (err) {}
  }, true);
  // after Shopify sends a message, its thank-you greets the sender by first name, as in the draft
  [].forEach.call(document.querySelectorAll("[data-cg-done]:not([hidden])"), function (done) {
    var key = "cg-sent-" + done.getAttribute("data-cg-done"), name = "", b = done.querySelector("b"), t = done.getAttribute("data-thanks");
    try { name = sessionStorage.getItem(key) || ""; sessionStorage.removeItem(key); } catch (err) {}
    if (name && b && t) b.textContent = t.replace("[name]", name);
    done.focus();
  });
})();

  // app pages: monthly or yearly prices (monthly shows until a choice is made)
  (function () {
    Array.prototype.forEach.call(document.querySelectorAll("[data-a8-bill]"), function (box) {
      var btns = box.querySelectorAll("[data-a8-cycle]");
      Array.prototype.forEach.call(btns, function (b) {
        b.addEventListener("click", function () {
          var c = b.getAttribute("data-a8-cycle");
          box.setAttribute("data-cycle", c);
          Array.prototype.forEach.call(btns, function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        });
      });
    });
  })();

(function () {
  // the category buttons above the app list, as in the first Shopify draft: All, or one category
  var pills = document.querySelectorAll(".catfilter button");
  if (!pills.length) return;
  function setFilter(cat) {
    Array.prototype.forEach.call(pills, function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-filter") === cat ? "true" : "false"); });
    Array.prototype.forEach.call(document.querySelectorAll("#pg-apps .catsec"), function (g) { g.hidden = cat !== "all" && g.getAttribute("data-cat") !== cat; });
  }
  Array.prototype.forEach.call(pills, function (b) { b.addEventListener("click", function () { setFilter(b.getAttribute("data-filter")); }); });
})();

(function () {
  // Pricing (#29): the plans have one home, the store's Pricing entry (metaobject "pricing", handle "plans"),
  // printed as JSON by snippets/cg-pricing-data.liquid. Liquid draws the first app, monthly; this redraws the
  // cards when the app or the period changes. The words come from the section settings (data- attributes).
  var cfgEl = document.getElementById("pricing-config"), iconsEl = document.getElementById("pricing-icons");
  var planPick = document.getElementById("plan-app"), grid = document.querySelector(".plans4");
  if (!cfgEl || !planPick || !grid) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var PICONS = iconsEl ? JSON.parse(iconsEl.textContent) : {};
  var W = grid.dataset;
  var period = "monthly";
  var ESC = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (ch) { return ESC[ch]; }); }
  function money(v) { return "$" + Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, ""); }
  function num(v) { return Number(v).toLocaleString("en-US"); }
  function blank(w) { return '<i class="blank">' + esc(w) + "</i>"; }
  // while the Pricing entry has Placeholder on, every price and credit amount carries the [sample] mark
  var mark = W.sample ? '<small class="cg-sample">' + esc(W.sample) + "</small>" : "";
  var markSp = mark ? mark + " " : "";
  function showPlans() {
    var key = planPick.value, app = CFG.apps && CFG.apps[key];
    if (!app) return;
    var opt = planPick.options[planPick.selectedIndex];
    var url = opt.getAttribute("data-url") || "", ext = url !== "" && url.charAt(0) !== "/";
    var ic = document.getElementById("pp-icon");
    ic.className = "aic c-" + (opt.getAttribute("data-cat") || app.cat);
    if (PICONS[key]) ic.innerHTML = PICONS[key];
    // an app without its own App Store listing yet: its availability and Book a meeting instead of the plan buttons
    var soon = document.getElementById("pp-soon"), tag = document.getElementById("pp-tag");
    if (soon) soon.hidden = !!url;
    if (tag && !url) {
      tag.textContent = opt.getAttribute("data-tag") || "";
      tag.className = "status " + (opt.getAttribute("data-tag-key") || "soon");
    }
    document.getElementById("pp-unit").innerHTML = markSp + esc(app.perCredit);
    document.getElementById("pp-incl").innerHTML = (app.included || []).map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("");
    Array.prototype.forEach.call(grid.querySelectorAll(".plan"), function (card) {
      var i = +card.getAttribute("data-i"), plan = CFG.plans[i].key;
      var m = app.monthly ? app.monthly[i] : null, c = app.credits ? app.credits[i] : null;
      var price = card.querySelector("[data-price]"), cr = card.querySelector("[data-credits]"), pk = card.querySelector("[data-pack]"), btn = card.querySelector("[data-plan]");
      var per = "<span>" + esc(period === "yearly" ? W.perYear : W.perMonth) + "</span>";
      if (i === 0) price.innerHTML = "<b>" + money(0) + "</b><span>" + esc(W.freeNote) + "</span>";
      else if (m == null) price.innerHTML = "<b>$</b>" + blank(W.blankPrice) + per;
      else if (period === "yearly") price.innerHTML = mark + "<b>" + money(m * CFG.yearlyMonths) + "</b>" + per + "<em>" + esc(W.yearlyNote) + "</em>";
      else price.innerHTML = mark + "<b>" + money(m) + "</b>" + per;
      cr.innerHTML = c == null ? blank(W.blankNumber) : markSp + num(c) + " " + esc(app.unit);
      var p = app.packs ? app.packs[plan] : null;
      if (i > 0 && period === "yearly") pk.textContent = W.noPacks;
      else pk.innerHTML = p ? markSp + esc(W.packLine.replace("[credits]", function () { return num(p[0]); }).replace("[price]", function () { return money(p[1]); })) : "";
      if (btn) btn.hidden = !url;
      if (btn && url) {
        btn.setAttribute("href", url);
        if (ext) { btn.setAttribute("target", "_blank"); btn.setAttribute("rel", "noopener"); }
        else { btn.removeAttribute("target"); btn.removeAttribute("rel"); }
      }
    });
  }
  planPick.addEventListener("change", showPlans);
  var toggles = document.querySelectorAll(".ptoggle button");
  Array.prototype.forEach.call(toggles, function (b) {
    b.addEventListener("click", function () {
      period = b.getAttribute("data-period");
      Array.prototype.forEach.call(toggles, function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
      showPlans();
    });
  });
  // a browser that kept an earlier choice of app (the back button) gets the cards for that app
  if (planPick.selectedIndex > 0) showPlans();
})();

  // version 3: the real number counts up once, when it comes into view (the page shows 1,507 at rest)
  (function () {
    var el = document.querySelector(".v3-num");
    if (!el || !("IntersectionObserver" in window)) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var target = parseInt(el.getAttribute("data-count"), 10), done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || done) return;
        done = true; io.disconnect();
        var t0 = performance.now();
        (function step(t) {
          var p = Math.min(1, (t - t0) / 1300), v = Math.round(target * (1 - Math.pow(1 - p, 3)));
          el.textContent = v.toLocaleString("en-US");
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      });
    }, { threshold: 0.6 });
    io.observe(el);
  })();

  // version 4: the before-and-after carousel
  (function () {
    var root = document.querySelector(".ba");
    if (!root) return;
    var slides = root.querySelectorAll(".ba-slide"), tabs = root.querySelectorAll(".ba-tab"), dots = root.querySelectorAll(".ba-dot");
    var i = 0, timer = null, stopped = false, hover = false;
    var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function go(n, byUser) {
      i = (n + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function (s, k) { s.classList.toggle("is-on", k === i); });
      Array.prototype.forEach.call(tabs, function (t, k) { t.setAttribute("aria-selected", k === i ? "true" : "false"); });
      Array.prototype.forEach.call(dots, function (d, k) { if (k === i) d.setAttribute("aria-current", "true"); else d.removeAttribute("aria-current"); });
      if (byUser) { stopped = true; clearInterval(timer); timer = null; }
    }
    function tick() { if (!hover && root.offsetParent !== null) go(i + 1); }
    function start() { if (still || stopped || timer) return; timer = setInterval(tick, 6500); }
    Array.prototype.forEach.call(tabs, function (t) { t.addEventListener("click", function () { go(+t.getAttribute("data-slide"), true); }); });
    Array.prototype.forEach.call(dots, function (d) { d.addEventListener("click", function () { go(+d.getAttribute("data-slide"), true); }); });
    root.querySelector(".ba-prev").addEventListener("click", function () { go(i - 1, true); });
    root.querySelector(".ba-next").addEventListener("click", function () { go(i + 1, true); });
    root.addEventListener("mouseenter", function () { hover = true; });
    root.addEventListener("mouseleave", function () { hover = false; });
    root.addEventListener("focusin", function () { hover = true; });
    root.addEventListener("focusout", function () { hover = false; });
    start();
  })();

  // version 4: Book a meeting, a short form with three paths; the last step sends it with Shopify's contact form (#28)
  (function () {
    var form = document.getElementById("st-form");
    if (!form) return;
    var flows = { "new": ["path", "new-where", "new-what", "contact"], operate: ["path", "op-store", "op-pain", "contact"], apps: ["path", "apps-pick", "contact"] };
    var steps = form.querySelectorAll(".st-step"), cur = 0, path = null;
    var next = document.getElementById("st-next"), back = document.getElementById("st-back"), err = document.getElementById("st-err");
    var stepL = document.getElementById("st-step-l"), done = document.getElementById("st-done"), doneH = document.getElementById("st-done-h");
    var nextLabel = next ? next.textContent : "", serverErr = err.hidden ? "" : err.textContent.trim();
    function word(k) { return err.getAttribute("data-" + k) || ""; }
    function flow() { return path ? flows[path] : ["path"]; }
    function val(id) { var e = document.getElementById(id); return e ? e.value.trim() : ""; }
    function picked(name) { return Array.prototype.map.call(form.querySelectorAll('input[name="' + name + '"]:checked'), function (x) { return x.value; }); }
    // what a pick reads like: the path's short name, or the chip's own words
    function shown(name) {
      return Array.prototype.map.call(form.querySelectorAll('input[name="' + name + '"]:checked'), function (x) {
        return x.getAttribute("data-label") || x.parentNode.textContent.replace(/\s+/g, " ").trim();
      });
    }
    function showErr(msg) { err.textContent = msg; err.hidden = !msg; }
    function render() {
      var f = flow(), total = path ? f.length : 4;
      Array.prototype.forEach.call(steps, function (s) { s.hidden = s.getAttribute("data-step") !== f[cur]; });
      Array.prototype.forEach.call(form.elements, function (el) { el.disabled = false; });
      stepL.textContent = (stepL.getAttribute("data-of") || "").replace("[n]", cur + 1).replace("[total]", total);
      document.getElementById("st-bar").style.width = Math.round(((cur + 1) / total) * 100) + "%";
      if (back) back.hidden = cur === 0;
      if (next) next.textContent = cur === f.length - 1 && path ? (next.getAttribute("data-last") || nextLabel) : nextLabel;
      Array.prototype.forEach.call(form.querySelectorAll(".st-cond"), function (c) {
        var w = c.getAttribute("data-when").split(":");
        c.hidden = picked(w[0]).indexOf(w[1]) < 0;
      });
      showErr("");
    }
    function ok() {
      var step = flow()[cur];
      if (step === "path" && !path) return "path";
      if (step === "op-store" && !/^https?:\/\/.+\..+/.test(val("st-op-url"))) return "url";
      if (step === "op-pain" && picked("pain").length === 0) return "pick";
      if (step === "apps-pick" && picked("apps").length === 0) return "apps";
      if (step === "contact") {
        if (!val("st-name")) return "name";
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val("st-email"))) return "email";
      }
      return "";
    }
    function row(dl, k, v) { if (!v) return; var dt = document.createElement("dt"), dd = document.createElement("dd"); dt.textContent = k; dd.textContent = v; dl.appendChild(dt); dl.appendChild(dd); }
    // only the chosen path travels: the answers of its steps, never a closed question or another path's step
    function send() {
      var f = flow(), rows = [];
      Array.prototype.forEach.call(form.querySelectorAll("[data-sum]"), function (el) {
        var step = el.closest(".st-step"), cond = el.closest(".st-cond");
        if (el.hasAttribute("data-group")) el.value = shown(el.getAttribute("data-group")).join(", ");
        var v = el.value.trim(), live = !!step && f.indexOf(step.getAttribute("data-step")) >= 0 && !(cond && cond.hidden);
        el.disabled = !live || !v;
        if (!el.disabled) rows.push([el.getAttribute("data-sum"), v]);
      });
      // the taps themselves stay home: their answers travel in the fields above
      Array.prototype.forEach.call(form.querySelectorAll(".st-path input, .st-chip input"), function (x) { x.disabled = true; });
      try { sessionStorage.setItem("cg-sent-st-form", JSON.stringify({ name: val("st-name").split(/\s+/)[0], rows: rows })); } catch (e) {}
    }
    // back from Shopify: the thank-you, with the summary of what was sent
    function thanks() {
      var sent = null, dl = document.getElementById("st-sum");
      try { sent = JSON.parse(sessionStorage.getItem("cg-sent-st-form") || "null"); sessionStorage.removeItem("cg-sent-st-form"); } catch (e) {}
      dl.innerHTML = "";
      if (sent && sent.rows) sent.rows.forEach(function (r) { row(dl, r[0], r[1]); });
      dl.hidden = !dl.children.length;
      if (sent && sent.name && doneH && doneH.getAttribute("data-thanks")) doneH.textContent = doneH.getAttribute("data-thanks").replace("[name]", sent.name);
      Array.prototype.forEach.call(steps, function (s) { s.hidden = true; });
      form.querySelector(".st-actions").hidden = true; form.querySelector(".st-prog").hidden = true;
      done.hidden = false; showErr(""); done.focus();
    }
    // Next is the form's submit button. A step forward or a missing answer stops the event before Shopify's spam
    // protection hears it (it would send the form); only the last step, complete, goes on to Shopify.
    window.addEventListener("submit", function (e) {
      if (e.target !== form) return;
      var m = ok(), last = cur === flow().length - 1;
      if (m || !last) { e.preventDefault(); e.stopImmediatePropagation(); }
      if (m) { showErr(word(m)); return; }
      if (!last) { cur++; render(); return; }
      send(); // the browser now sends the form to Shopify, which comes back with the thank-you
    }, true);
    if (back) back.addEventListener("click", function () { if (cur > 0) { cur--; render(); } });
    Array.prototype.forEach.call(form.querySelectorAll('input[name="path"]'), function (r) {
      r.addEventListener("change", function () { path = r.value; render(); setTimeout(function () { if (cur === 0) { cur = 1; render(); } }, 180); });
    });
    form.addEventListener("change", function (e) {
      if (e.target.name === "pain" && picked("pain").length > 3) { e.target.checked = false; showErr(word("three")); return; }
      render();
    });
    var again = document.getElementById("st-again");
    if (again) again.addEventListener("click", function () { window.cgStart("start"); });
    window.cgStart = function (id) {
      form.reset(); path = null; cur = 0;
      form.querySelector(".st-actions").hidden = false; form.querySelector(".st-prog").hidden = false; done.hidden = true;
      var p = id === "start-new" ? "new" : id === "start-operate" ? "operate" : id === "start-apps" ? "apps" : null;
      if (p) { path = p; var r = document.getElementById("st-path-" + p); if (r) r.checked = true; cur = 1; }
      render();
    };
    // a page restored from the back button gets its fields back
    window.addEventListener("pageshow", function (e) { if (e.persisted && done.hidden) render(); });
    if (!done.hidden) { thanks(); return; }
    render();
    if (serverErr) showErr(serverErr);
    else if (/^#start/.test(location.hash)) window.cgStart(location.hash.slice(1));
  })();

  // version 5: hero option 2, one store before and after. Drag the handle; it peeks once when it comes into view.
  (function () {
    var view = document.getElementById("sx-view");
    if (!view) return;
    var handle = view.querySelector(".sx-handle"), REST = 22, x = REST, touched = false, raf = 0, dragging = false;
    function setX(v) {
      x = Math.max(0, Math.min(100, v));
      view.style.setProperty("--x", x.toFixed(2));
      handle.setAttribute("aria-valuenow", String(Math.round(x)));
    }
    function fit() { var w = view.clientWidth; if (w) view.style.setProperty("--k", (w / 1040).toFixed(4)); }
    fit();
    if ("ResizeObserver" in window) new ResizeObserver(fit).observe(view); else window.addEventListener("resize", fit);
    function stop() { if (raf) cancelAnimationFrame(raf); raf = 0; }
    function glide(to, ms, then) {
      stop();
      var from = x, t0 = performance.now();
      (function step(t) {
        var p = Math.min(1, (t - t0) / ms), e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        setX(from + (to - from) * e);
        if (p < 1) raf = requestAnimationFrame(step); else { raf = 0; if (then) then(); }
      })(t0);
    }
    function at(e) { var r = view.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; }
    view.addEventListener("pointerdown", function (e) {
      touched = true; stop(); dragging = true;
      try { view.setPointerCapture(e.pointerId); } catch (err) {}
      setX(at(e));
    });
    view.addEventListener("pointermove", function (e) { if (dragging) setX(at(e)); });
    ["pointerup", "pointercancel", "lostpointercapture"].forEach(function (n) { view.addEventListener(n, function () { dragging = false; }); });
    handle.addEventListener("keydown", function (e) {
      var to = null;
      if (e.key === "ArrowLeft" || e.key === "ArrowDown") to = x - 5;
      else if (e.key === "ArrowRight" || e.key === "ArrowUp") to = x + 5;
      else if (e.key === "Home") to = 0;
      else if (e.key === "End") to = 100;
      if (to === null) return;
      e.preventDefault(); touched = true; stop(); setX(to);
    });
    setX(REST);
    var calm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!calm && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        if (touched) return;
        glide(72, 900, function () { setTimeout(function () { if (!touched) glide(REST, 1000); }, 250); });
      }, { threshold: 0.5 });
      io.observe(view);
    }
    // the key: point at an app and its number lights up; a hidden one slides into view
    Array.prototype.forEach.call(document.querySelectorAll(".sx-legend li"), function (li) {
      var dot = view.querySelector('.sx-dot[data-dot="' + li.getAttribute("data-dot") + '"]');
      if (!dot) return;
      function on() {
        li.classList.add("hot"); dot.classList.add("hot");
        var dx = parseFloat(dot.style.left);
        if (dx < x + 3) { touched = true; glide(Math.max(2, dx - 8), 450); }
      }
      function off() { li.classList.remove("hot"); dot.classList.remove("hot"); }
      li.addEventListener("mouseenter", on); li.addEventListener("mouseleave", off);
      li.addEventListener("focusin", on); li.addEventListener("focusout", off);
    });
  })();
  // version 5: the bars under 1,506 grow once, with the count
  (function () {
    var box = document.querySelector(".v5-proof");
    if (!box || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return;
      io.disconnect(); box.classList.add("is-in");
    }, { threshold: 0.4 });
    io.observe(box);
  })();

  // version 7: Support search, the copy buttons and the contact form
  (function () {
    var box = document.getElementById("sp-search");
    if (box) {
      var items = [].slice.call(document.querySelectorAll("#pg-support .p7-q"));
      var groups = [].slice.call(document.querySelectorAll("#pg-support .p7-topic"));
      var none = document.getElementById("sp-none");
      box.addEventListener("input", function () {
        var q = box.value.trim().toLowerCase(), hits = 0;
        items.forEach(function (it) { var ok = !q || it.textContent.toLowerCase().indexOf(q) >= 0; it.hidden = !ok; if (ok) hits++; });
        groups.forEach(function (g) { g.hidden = !!q && !g.querySelector(".p7-q:not([hidden])"); });
        none.hidden = hits > 0;
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll("[data-copy]"), function (b) {
      var label = b.textContent, yes = b.getAttribute("data-copied") || "Copied", no = b.getAttribute("data-copy-fail") || "Select the address to copy it";
      b.addEventListener("click", function () {
        function say(msg) { b.textContent = msg; setTimeout(function () { b.textContent = label; }, 1800); }
        try { navigator.clipboard.writeText(b.getAttribute("data-copy")).then(function () { say(yes); }, function () { say(no); }); }
        catch (e) { say(no); }
      });
    });
  })();

  // steps 4 and 5 (2026-10-17): the blog's topic filter, and the Request a feature form (like Contact: checks, then thanks)
  (function () {
    var bf = document.querySelectorAll("[data-blog-f]");
    Array.prototype.forEach.call(bf, function (b) {
      b.addEventListener("click", function () {
        var f = b.getAttribute("data-blog-f");
        Array.prototype.forEach.call(bf, function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        Array.prototype.forEach.call(document.querySelectorAll("[data-blog-tag]"), function (c) { c.hidden = f !== "all" && c.getAttribute("data-blog-tag") !== f; });
      });
    });
  })();

// Cookie banner (#17, Rudy 2026-10-18): Shopify's banner shows as a small card about 4 seconds after Shopify adds it
// (cg-site.css), stays about 6 seconds, then steps back into the round button of the cg-cookie-pill template
// (layout/cg.liquid). Hover, focus or a tap opens the card above it; Escape, a tap outside or focus moving on closes
// it. When the visitor chooses, Shopify hides its banner (display: none) without removing it; from then on the banner
// counts as gone: the timer stops, the button goes and the hidden banner is never picked up again. Nothing here
// touches consent: no click is sent to Shopify's buttons and no setting changes.
(function () {
  var tpl = document.getElementById("cg-cookie-pill");
  if (!tpl || !tpl.content || !window.MutationObserver) return;
  var html = document.documentElement, banner = null, pill = null, spent = null, watcher = null;
  var sticky = false, hover = false, quiet = false, started = false, leaveT, stepT;
  function state() { return html.getAttribute("data-cg-cookie"); }
  function gone(b) { return !b.isConnected || b.style.display === "none" || getComputedStyle(b).display === "none"; }
  function has(el) { return !!el && ((!!banner && banner.contains(el)) || (!!pill && pill.contains(el))); }
  function inPrefs(el) { return !!(el && el.closest && el.closest("#shopify-pc__prefs")); }
  function busy() { var a = document.activeElement; return hover || has(a) || inPrefs(a); }
  function set(s) { html.setAttribute("data-cg-cookie", s); if (pill) pill.setAttribute("aria-expanded", String(s === "open")); }
  function toPill() { quiet = true; pill.focus(); quiet = false; }
  function open(stick) { clearTimeout(leaveT); if (stick) sticky = true; if (state() !== "open") set("open"); }
  function close(refocus) {
    var back = refocus && has(document.activeElement);
    sticky = false; clearTimeout(leaveT);
    set(state() === "open" ? "closed" : "mini");
    if (back) toPill();
  }
  function watch(el) {
    el.addEventListener("pointerenter", function (e) { if (e.pointerType !== "mouse") return; hover = true; if (pill) open(false); });
    el.addEventListener("pointerleave", function (e) {
      if (e.pointerType !== "mouse") return;
      hover = false; clearTimeout(leaveT);
      leaveT = setTimeout(function () { if (pill && state() === "open" && !sticky && !busy()) close(false); }, 400);
    });
  }
  function stepBack(now) {
    if (!banner || pill || gone(banner)) return;
    if (!now && busy()) { stepT = setTimeout(stepBack, 1500); return; } // never while the visitor reads or uses the card
    pill = tpl.content.firstElementChild.cloneNode(true);
    banner.parentNode.insertBefore(pill, banner); // before the card, so Tab goes from the button into it
    pill.addEventListener("click", function () { if (state() === "open" && sticky) close(false); else open(true); });
    pill.addEventListener("focus", function () { if (!quiet) open(false); });
    watch(pill);
    set("mini");
    if (now) toPill();
  }
  function start() { if (!started && banner && !gone(banner)) { started = true; stepT = setTimeout(stepBack, 6000); } }
  function drop() {
    if (pill) pill.remove();
    if (watcher) watcher.disconnect();
    html.removeAttribute("data-cg-cookie");
    clearTimeout(leaveT); clearTimeout(stepT);
    banner = pill = watcher = null; sticky = hover = false;
  }
  function attach(b) {
    banner = b; started = false;
    watch(b);
    b.addEventListener("animationend", function (e) { if (e.target === b && b === banner && /^cg-pc-(in|show)$/.test(e.animationName)) start(); });
    watcher = new MutationObserver(sync); // Shopify hides the banner through its style attribute
    watcher.observe(b, { attributes: true, attributeFilter: ["style", "class", "hidden"] });
    var cs = getComputedStyle(b);
    if (cs.visibility === "visible" && cs.animationName !== "none") start(); // it was already showing
  }
  function sync() {
    if (banner && gone(banner)) { spent = banner.isConnected ? banner : null; drop(); } // the visitor chose
    var b = document.getElementById("shopify-pc__banner");
    if (b && b !== banner && b !== spent && !gone(b)) { drop(); attach(b); }
  }
  new MutationObserver(sync).observe(document.body, { childList: true });
  document.addEventListener("visitorConsentCollected", function () { setTimeout(sync, 0); });
  sync();
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !banner || inPrefs(e.target)) return;
    if (state() === "open") close(true);
    else if (!pill && has(document.activeElement)) stepBack(true);
  });
  document.addEventListener("pointerdown", function (e) { if (state() === "open" && !has(e.target) && !inPrefs(e.target)) close(false); }, true);
  document.addEventListener("focusin", function (e) { if (state() === "open" && !has(e.target) && !inPrefs(e.target) && !hover) close(false); });
})();

// Cookie choices (#111): the footer's button (sections/cg-footer.liquid) reopens Shopify's cookie preferences at any
// time, with the Cookie Banner API's privacyBanner.showPreferences()
// (https://shopify.dev/docs/api/customer-privacy#showing-the-preferences-modal). Shopify's banner script loads on
// its own schedule, so the button stays hidden until the call exists (checked for about 15 seconds) and never
// opens nothing. Choosing stays Shopify's: this only opens its dialog.
(function () {
  var btns = [].slice.call(document.querySelectorAll("[data-cg-cookie-choices]"));
  if (!btns.length) return;
  function api() { var p = window.privacyBanner; return p && typeof p.showPreferences === "function" ? p : null; }
  btns.forEach(function (b) {
    b.addEventListener("click", function () {
      var p = api();
      if (!p) return;
      try { Promise.resolve(p.showPreferences()).catch(function () {}); } catch (err) {}
    });
  });
  var tries = 0;
  (function ready() {
    if (api()) { btns.forEach(function (b) { b.hidden = false; }); return; }
    if (++tries < 60) setTimeout(ready, 250);
  })();
})();

(function () {
  // the waitlist form (#96, sections/cg-waitlist.liquid): ticks the Agent Apps a link names (?apps=video,social) and
  // keeps Shopify's customer tags current on every change: waitlist, waitlist-<handle> per ticked app,
  // store:<address>. Never only on submit: Shopify's spam protection can send the form itself (see above)
  var form = document.querySelector("form[data-cg-waitlist]");
  if (!form) return;
  var tags = form.querySelector("[data-wl-tags]"), store = form.querySelector("[data-wl-store]");
  if (!tags) return;
  var boxes = [].slice.call(form.querySelectorAll("[data-wl-app]"));
  var want = [];
  try { want = (new URLSearchParams(location.search).get("apps") || "").toLowerCase().split(","); } catch (err) {}
  boxes.forEach(function (b) { if (want.indexOf(b.value) >= 0) b.checked = true; });
  function write() {
    var list = ["waitlist"];
    boxes.forEach(function (b) { if (b.checked) list.push("waitlist-" + b.value); });
    var s = store ? store.value.trim().toLowerCase().replace(/^https?:\/\//, "").replace(/[,\s]+/g, "").replace(/\/+$/, "") : "";
    if (s) list.push("store:" + s.slice(0, 200));
    tags.value = list.join(", ");
  }
  form.addEventListener("change", write);
  form.addEventListener("input", write);
  form.addEventListener("submit", write, true);
  write();
})();
